<template>
	<div class="interview">
		<div class="interviewCon">
			<div class="head container">
				<div>
					个人中心
				</div>
			</div>

			<div class="center">
				<el-calendar v-model="value" class="calendar">
					<template slot="dateCell" slot-scope="{date, data}">
						<div class="dates" @click="changeDate(date)">
							{{convert(date)}}
						</div>
					</template>
				</el-calendar>
				<div class="right container">
					<div class="date">
						{{selectDate}}，{{selectWeek}}
					</div>
					<div class="ul">
						<div  v-for="index of 18" class="popover" @click="id=index">
							<el-popover placement="top-end" width="434" trigger="click" :value="text(index)">
								<div class="li" slot="reference">
									<div class="time">
										09:20
									</div>
									<div class="avatarCon">
										<img src="@/static/logo.png" class="logo" />
										<div class="namePo">
											<div class="name">
												农怡
											</div>
											<div class="position">
												双流质检双流质检
											</div>
										</div>
									</div>
									<div class="phone">
										138000000000
									</div>
									<div class="status">
										<div class="dot"></div>
										<div>
											开放中
											<!-- 审核失败 -->
											<!-- 已关闭 -->
										</div>
									</div>
									<div class="controls">
										<div class="button" style="color: #51A190;">发送结果</div>
									</div>
								</div>
							
							    <div class="popup">
									<div class="top">
										<div class="">
											面试已完成
										</div>
										<img src="@/static/close.png" class="icon" @click="id=''" />
									</div>
									<div class="avatarCon">
										<img src="@/static/logo.png" class="avatar" />
										<div class="">
											农怡
										</div>
									</div>
									<div class="argument">
										<div class="argumentLi">
											<div class="label">
												时间
											</div>
											<div class="value">
												2023年9月16日 09:20
											</div>
										</div>
										<div class="argumentLi">
											<div class="label">
												职位
											</div>
											<div class="value">
												双流质检员包三餐坐班5k+ 4500-6
											</div>
										</div>
										<div class="argumentLi">
											<div class="label">
												电话
											</div>
											<div class="value">
												13800000000
											</div>
										</div>
										<div class="argumentLi">
											<div class="label">
												地址
											</div>
											<div class="value">
												成都锦江区
											</div>
										</div>
									</div>
								    <div class="buttonG">
										 <el-button type="primary" plain>查看简历</el-button>
										 <el-button type="primary" plain>发送结果</el-button>
										 <el-button type="primary">重新邀约</el-button>
									</div>
								</div>
							</el-popover>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: new Date(),
				selectDate: '',
				selectWeek: '',
				visible:false,
				id:''
			}
		},
		created() {
			this.selectDate = this.getyear()
			this.selectWeek = this.getweek()
		},
		methods: {
			text(index){
				if(index==this.id) return true
			},
			// 转为几号
			convert(date) {
				const clickedDate = new Date(date);
				const dayOfMonth = clickedDate.getDate();
				return dayOfMonth
			},
			// 获取年月日
			getyear(dateString) {
				let date = ''
				if (dateString) {
					date = new Date(dateString);
				} else {
					date = new Date();
				}
				const year = date.getFullYear();
				const month = date.getMonth() + 1;
				const day = date.getDate();
				return `${month < 10 ? '0' : ''}${month}月${day < 10 ? '0' : ''}${day}日`
			},
			// 获取星期几
			getweek(dateString) {
				let date = ''
				if (dateString) {
					date = new Date(dateString);
				} else {
					date = new Date();
				}
				const dayOfWeek = date.getDay();
				return dayOfWeek == 0 ? '星期日' : `星期${dayOfWeek}`
			},
			time(date) {
				// 假设你有一个点击的日期字符串
				const clickedDateString = date;
				// 使用 Date 对象将日期字符串转换为时间戳
				const clickedDate = new Date(clickedDateString);
				const timestamp = clickedDate.getTime()
				return timestamp
			},
			// 点击日期
			changeDate(date) {
				// 假设 date 是从 @click 事件中获取的日期对象
				const clickedDate = new Date(date);
				// 获取星期几的数字（0 表示星期天，1 表示星期一，以此类推）
				const dayOfWeek = clickedDate.getDay();
				this.getweek(date)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.el-button{
		border-radius: 8px !important;
		font-size: 16px !important;
	}
	
	.interview {
		position: relative;
		padding: 38px 0;
		display: flex;
		justify-content: center;
		.interviewCon {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;

			.container {
				padding: 28px 32px;
				background-color: #FFF;
				border-radius: 12px;
				margin-bottom: 24px;
			}

			.head {
				font-size: 28px;
			}
			

			.center {
				display: flex;
				align-items: flex-start;

				.dates {
					width: 100%;
					height: 29px;
					line-height: 29px;
					text-align: center;
				}

				.calendar {
					width: 394px;
					height: 400px;
					border-radius: 16px;
					margin-right: 16px;
				}

				.right {
					flex: 1;
					color: #181C2E;
					font-size: 20px;
					height: 640px;
					display: flex;
					flex-direction: column;
					.date {
						margin-bottom: 40px;
					}
					
					::-webkit-scrollbar {
						width: 6px;
						/*  设置纵轴（y轴）轴滚动条 */
					}
					
					/* 滚动条滑块（里面小方块） */
					::-webkit-scrollbar-thumb {
						border-radius: 10px;
						background: rgba(0, 0, 0, 0.2);
					}
					
					/* 滚动条轨道 */
					::-webkit-scrollbar-track {
						background: rgba(0,0,0, 0.1);
						border-radius: 10px;
						margin: 10px 0;
					}
					.ul{
						flex: 1;
						overflow-y: auto;
						height: 574px;
						.popover{
							margin-bottom: 38px;
							&:last-child{
								margin-bottom: 0;
							}
						}
						.li {
							display: flex;
							align-items: center;
							color: #151515;
							
							
							.time {
								font-size: 14px;
								margin-right: 18px;
							}
						
							.avatarCon {
								display: flex;
								align-items: center;
								margin-right: 78px;
								.logo {
									width: 58px;
									height: 58px;
									margin-right: 18px;
									border-radius: 50%;
								}
						
								.namePo {
									height: 58px;
									display: flex;
									flex-direction: column;
									justify-content: space-between;
						
									.name {
										font-size: 18px;
									}
						
									.position {
										color: #A3A7B3;
										font-size: 14px;
										white-space: nowrap;
										overflow: hidden;
										width: 98px;
										text-overflow: ellipsis;
									}
								}
							}
						
							.phone {
								font-size: 16px;
								margin-right: 75px;
							}
						
							.status {
								display: flex;
								align-items: center;
								font-size: 16px;
								margin-right: 66px;
								.dot {
									width: 12px;
									height: 12px;
									border-radius: 50%;
									background-color: #51A190;
									margin-right: 6px;
								}
						
								color: #151515;
							}
						
							.controls {
								display: flex;
								align-items: center;
						
								.button {
									margin-right: 38px;
									font-size: 16px;
									cursor: pointer;
									&:last-child {
										margin-right: 0;
									}
								}
							}
						}
					}

					
				}
			}
		}
	}
</style>

<style lang="scss">
	 .el-calendar-table .el-calendar-day {
		height: 45px !important;
	}
	.el-popover{
		padding: 28px !important;
		border-radius: 16px !important;
	}
	
	
	.popup{
		color: #151515;
		.top{
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 18px;
			margin-bottom: 12px;
			font-weight: bold;
			.icon{
				width: 16px;
				cursor: pointer;
				height: 16px;
			}
		}
		.avatarCon{
			display: flex;
			align-items: center;
			margin-bottom: 18px;
			.avatar{
				width: 32px;
				height: 32px;
				margin-right: 8px;
				border-radius: 50%;
			}
			font-size: 16px;
		}
		.argument{
			margin-bottom: 26px;
			.argumentLi{
				display: flex;
				align-items: center;
				font-size: 14px;
				margin-bottom: 14px;
				&:last-child{
					margin-bottom: 0;
				}
				.label{
					color: #868686;
					margin-right: 38px;
				}
				.value{
					color: #151515;
				}
			}
		}
		.buttonG{
			display: flex;
			align-items: center;
			justify-content: flex-end;
			
		}
	}
	
	
</style>